/* @flow */
import formSerialize from 'form-serialize';
import moment from 'moment';
import get from 'lodash/get';
import getFormularioPorId from '../utils/get-formulario-por-id';
import swal from '../utils/swal';
import { exibirToastSucesso, exibirToastError } from '../utils/alertas';
import api from '../utils/api';
import { type Empresa } from '../empresa/types';

const formulario = `
<br/>
<form id="adicionar-funcionario" class="m-form m-form--fit m-form--label-align-right">
    <div class="m-portlet__body">
        <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-3 col-sm-12" for="nome-usuarios">
                Nome:
            </label>
            <div class="col-lg-6 col-md-9 col-sm-12">
                <input
                    type="text"
                    name="nome"
                    id="nome-usuarios"
                    class="form-control m-input"
                    maxlength="35"
                    required
                />
            </div>
        </div>
        <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-3 col-sm-12" for="nascimento-usuarios">
                Nascimento:
            </label>
            <div class="col-lg-6 col-md-9 col-sm-12">
                <input
                    type="date"
                    name="nascimento"
                    id="nascimento-usuarios"
                    class="form-control m-input"
                    required
                />
            </div>
        </div>
        <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-3 col-sm-12" for="cpf-usuarios">
                CPF:
            </label>
            <div class="col-lg-6 col-md-9 col-sm-12">
                <input
                    type="text"
                    name="cpf"
                    id="cpf-usuarios"
                    class="form-control m-input"
                    maxlength="35"
                    required
                />
            </div>
        </div>
        <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-3 col-sm-12" for="email-usuarios">
                E-mail:
            </label>
            <div class="col-lg-6 col-md-9 col-sm-12">
                <input
                    type="text"
                    name="email"
                    id="email-usuarios"
                    class="form-control m-input"
                    maxlength="35"
                    required
                />
            </div>
        </div>
        <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-3 col-sm-12" for="senha-usuarios">
                Senha:
            </label>
            <div class="col-lg-6 col-md-9 col-sm-12">
                <input
                    type="password"
                    name="senha"
                    id="senha-usuarios"
                    class="form-control m-input"
                    maxlength="14"
                    required
                />
            </div>
        </div>
        <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-3 col-sm-12" for="ativo-usuarios-sim">
                Ativo?
                <span class="m--font-danger">*</span>
            </label>
            <div class="col-2">
                <div class="m-radio-inline">
                    <label class="m-radio m-radio--bold m-radio--state-success">
                        <input
                            type="radio"
                            name="ativo"
                            value="1"
                            checked
                        >
                                Sim
                            <span></span>
                    </label>
                    <label class="m-radio m-radio--bold m-radio--state-danger">
                        <input
                            type="radio"
                            name="ativo"
                            value="0"
                        >
                            Não
                        <span></span>
                    </label>
                </div>
            </div>
        </div>
        <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-3 col-sm-12" for="ativo-usuarios-sim">
                Nível:
                <span class="m--font-danger">*</span>
            </label>
            <div class="col-3">
                <div class="m-radio-inline">
                    <label class="m-radio m-radio--bold m-radio--state-brand">
                        <input
                            type="radio"
                            name="nivel"
                            value="A"
                            >
                                Administrador
                            <span></span>
                    </label>
                    <label class="m-radio m-radio--bold m-radio--state-info">
                        <input
                            type="radio"
                            name="nivel"
                            value="F"
                            checked
                        >
                            Comum
                        <span></span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</form>
`;

const getDadosForm = (form: HTMLElement): Object => (
    formSerialize(form, { hash: true, empty: true })
);

const dadosValidos = (data: Object) => {
    if (!data.nome) {
        swal.showValidationMessage('Nome é obrigatório');
        return false;
    }

    if (!moment(data.nascimento).isValid()) {
        swal.showValidationMessage('Data de nascimento é obrigatória');
        return false;
    }

    if (!data.senha) {
        swal.showValidationMessage('Por favor digite uma senha');
        return false;
    }

    if (!data.nivel) {
        swal.showValidationMessage('Nível é obrigatório');
        return false;
    }
    return true;
};

const adicionarFuncionario = async (empresa: Empresa) => {
    try {
        const { value } = await swal.fire({
            title: `Novo funcionário para a empresa ${empresa.fantasia}`,
            width: 1300,
            scrollbarPadding: false,
            confirmButtonColor: '#36a3f7',
            html: formulario,
            focusConfirm: false,
            preConfirm: async () => {
                const data = getDadosForm(getFormularioPorId('adicionar-funcionario'));

                if (!dadosValidos(data)) {
                    return;
                }

                const exchangeObject = {
                    ...data,
                    empresasId: empresa.id,
                };

                try {
                    await api.criarUsuario(exchangeObject);
                } catch (error) {
                    swal.showValidationMessage(get(
                        error,
                        'response.data.message',
                        'Algo deu errado ao cadastrar',
                    ));
                }
            },
        });

        if (value) {
            exibirToastSucesso('Funcionário cadastrado com sucesso');
        }
    } catch (error) {
        exibirToastError(get(
            error,
            'response.data.message',
            'Algo deu errado',
        ));
    }
};

export default adicionarFuncionario;
